export default __webpack_public_path__ + "static/media/DSC-1.ff9623e1.jpg";